const mode = window.location.host !== 'www.elephantstock.com' ? 'dev.' : '';
export const algoliaClient = (APP_ID, API_KEY) => {
    return {
        initIndex(index) {
            const endpoint = `https://algolia.${mode}elephantstock.net/indexes/${index}/query?x-algolia-api-key=${API_KEY}&x-algolia-application-id=${APP_ID}&data=`;
            return {
                async search(query, params) {
                    const response = await fetch(endpoint + JSON.stringify({
                        query,
                        ...params
                    }).replace(/&/g, '%26').replace(/\+/g, '%2B'));
                    return await response.json();
                }
            };
        },
        initRecommendations({ indexName = 'product_catalog', model = 'related-products', threshold = 0, maxRecommendations = 10 } = {}) {
            const endpoint = `https://algolia.${mode}elephantstock.net/indexes/*/recommendations?x-algolia-api-key=${API_KEY}&x-algolia-application-id=${APP_ID}&data=`;
            return {
                async get(ids) {
                    try {
                        const resp = await fetch(endpoint + encodeURI(JSON.stringify({
                            requests: ids.map(objectID => ({
                                indexName,
                                model,
                                threshold,
                                maxRecommendations,
                                objectID
                            }))
                        })));
                        if (!resp.ok)
                            return null;
                        const data = await resp.json();
                        return data.results;
                    }
                    catch (e) {
                        return null;
                    }
                }
            };
        }
    };
};
